/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JsonStratEnablerInfo
 */
export interface JsonStratEnablerInfo {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonStratEnablerInfo
     */
    allowedActions?: Array<JsonStratEnablerInfoAllowedActionsEnum>;
    /**
     * 
     * @type {number}
     * @memberof JsonStratEnablerInfo
     */
    companyDepartmentId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonStratEnablerInfo
     */
    companyPositionId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonStratEnablerInfo
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonStratEnablerInfo
     */
    createdBy?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonStratEnablerInfo
     */
    departmentId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonStratEnablerInfo
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonStratEnablerInfo
     */
    email?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonStratEnablerInfo
     */
    enablerId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonStratEnablerInfo
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonStratEnablerInfo
     */
    lastName?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonStratEnablerInfo
     */
    onepagerId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonStratEnablerInfo
     */
    orderNo?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonStratEnablerInfo
     */
    positionId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonStratEnablerInfo
     */
    status?: JsonStratEnablerInfoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof JsonStratEnablerInfo
     */
    stratUserId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonStratEnablerInfo
     */
    teamName?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonStratEnablerInfo
     */
    updatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonStratEnablerInfo
     */
    updatedBy?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonStratEnablerInfo
     */
    userId?: number;
}

/**
* @export
* @enum {string}
*/
export enum JsonStratEnablerInfoAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}/**
* @export
* @enum {string}
*/
export enum JsonStratEnablerInfoStatusEnum {
    Deleted = 'DELETED',
    Active = 'ACTIVE'
}

export function JsonStratEnablerInfoFromJSON(json: any): JsonStratEnablerInfo {
    return JsonStratEnablerInfoFromJSONTyped(json, false);
}

export function JsonStratEnablerInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonStratEnablerInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'companyDepartmentId': !exists(json, 'companyDepartmentId') ? undefined : json['companyDepartmentId'],
        'companyPositionId': !exists(json, 'companyPositionId') ? undefined : json['companyPositionId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'departmentId': !exists(json, 'departmentId') ? undefined : json['departmentId'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'enablerId': !exists(json, 'enablerId') ? undefined : json['enablerId'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'onepagerId': !exists(json, 'onepagerId') ? undefined : json['onepagerId'],
        'orderNo': !exists(json, 'orderNo') ? undefined : json['orderNo'],
        'positionId': !exists(json, 'positionId') ? undefined : json['positionId'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'stratUserId': !exists(json, 'stratUserId') ? undefined : json['stratUserId'],
        'teamName': !exists(json, 'teamName') ? undefined : json['teamName'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
    };
}

export function JsonStratEnablerInfoToJSON(value?: JsonStratEnablerInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedActions': value.allowedActions,
        'companyDepartmentId': value.companyDepartmentId,
        'companyPositionId': value.companyPositionId,
        'createdAt': value.createdAt,
        'createdBy': value.createdBy,
        'departmentId': value.departmentId,
        'description': value.description,
        'email': value.email,
        'enablerId': value.enablerId,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'onepagerId': value.onepagerId,
        'orderNo': value.orderNo,
        'positionId': value.positionId,
        'status': value.status,
        'stratUserId': value.stratUserId,
        'teamName': value.teamName,
        'updatedAt': value.updatedAt,
        'updatedBy': value.updatedBy,
        'userId': value.userId,
    };
}

